import { Routes } from '@angular/router';
import { StudioShellComponent } from './layout/studio-shell.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { sessionGuard } from './shared/guards/session.guard';
import { studioGuard } from './shared/guards/studio.guard';
import { approverGuard } from './shared/guards/approver.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'create' },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: '',
    component: StudioShellComponent,
    canActivate: [sessionGuard, studioGuard],
    children: [
      { path: 'home', redirectTo: 'create', pathMatch: 'full' },
      // Landing: the AI-first create experience; browsing lives on /agents.
      {
        path: 'create',
        canActivate: [approverGuard],
        loadComponent: () =>
          import('./pages/agents/agent-create/agent-create.component').then((m) => m.AgentCreateComponent),
      },
      {
        path: 'agents',
        canActivate: [approverGuard],
        loadComponent: () =>
          import('./pages/agents/agent-list/agent-list.component').then((m) => m.AgentListComponent),
      },
      // Team directory: live published agents the caller can access (theirs +
      // shared). Literal path — must stay above the agents/:agent_id catch-all.
      {
        path: 'agents/directory',
        canActivate: [approverGuard],
        loadComponent: () =>
          import('./pages/agents/agent-directory/agent-directory.component').then((m) => m.AgentDirectoryComponent),
      },
      // Browse the full universe of abilities (available + roadmap), then start
      // a new agent pre-equipped with the chosen ones.
      {
        path: 'abilities',
        canActivate: [approverGuard],
        loadComponent: () =>
          import('./pages/abilities/abilities-library.component').then((m) => m.AbilitiesLibraryComponent),
      },
      {
        path: 'agents/new',
        canActivate: [approverGuard],
        loadComponent: () =>
          import('./pages/agents/agent-wizard/agent-wizard.component').then((m) => m.AgentWizardComponent),
      },
      {
        path: 'agents/edit/:agent_id',
        canActivate: [approverGuard],
        loadComponent: () =>
          import('./pages/agents/agent-wizard/agent-wizard.component').then((m) => m.AgentWizardComponent),
      },
      // Approvals is a single master-detail page; :id deep-links a selection.
      {
        path: 'agents/approvals',
        loadComponent: () =>
          import('./pages/agents/agent-approval-list/agent-approval-list.component').then((m) => m.AgentApprovalListComponent),
      },
      {
        path: 'agents/approvals/:id',
        loadComponent: () =>
          import('./pages/agents/agent-approval-list/agent-approval-list.component').then((m) => m.AgentApprovalListComponent),
      },
      {
        path: 'agents/:agent_id',
        canActivate: [approverGuard],
        loadComponent: () =>
          import('./pages/agents/agent-detail/agent-detail.component').then((m) => m.AgentDetailComponent),
      },
      { path: '**', redirectTo: 'create' },
    ],
  },
];
